import { render } from "./home-plans.vue?vue&type=template&id=aa40fc0a"
import script from "./home-plans.vue?vue&type=script&lang=js"
export * from "./home-plans.vue?vue&type=script&lang=js"

import "./home-plans.vue?vue&type=style&index=0&id=aa40fc0a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__